export const errorLiterals = {
  maximumRequest:
    'You have excedeed the maximum allowed request. Please, wait for a while',
  unavailableUser: 'Please, choose an available user'
};
